import { AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { from, Subject } from 'rxjs';
import { APIService } from '../../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { DataService} from 'src/app/services/data.service';
import { SubCategoriesComponent} from '../sub-categories/sub-categories.component';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})

export class CategoriesComponent implements OnInit, AfterViewInit {

  changingValue: Subject<boolean> = new Subject();
  constructor(private modalService: NgbModal,private router: Router,private apiService: APIService, private http: HttpClient, private dataSer: DataService, private route: ActivatedRoute) { }
  
  isEditCategory: boolean = false;
  ind: number = 0;
  category: string = '';
  jarvisData: any = [];
  categories: any = [];
  agencyData: any = [];
  @Input() mdlRef: any;
  modalshow:boolean = false
  @ViewChild('mymodal') addModalRef!: TemplateRef<any>;

//  *new var
  tempData: any = {
    subCategoryID: 0,
    categoryID: 0,
    categoryName: '',
    type: '' 
  }
 
  ngOnInit(): void {
    if(this.mdlRef){
      this.modalshow = true;
      }
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    this.getCategory()
  }

  ngAfterViewInit(): void {
    if (this.mdlRef) {
      this.open(this.addModalRef, 0);
    }

    this.route.queryParams.subscribe(params => {
      if (params['o'] == '1') {
        setTimeout(() => {
          this.open(this.addModalRef, 0);
        }, 100);
      }
    });
  }

  closeResult: any;
  modalReference: any;

  //getCategory() - get categories
  getCategory(){
    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'getConfig',
        moduleID: 6,
        data: ''
    }];
    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
    }

  //successResp - success  get handler   
  successResp(res: any) {
    if (res.error) {
    }
    else {
        if (res) {
            var reponseData = JSON.parse(res.updatePackage);
            if (reponseData.Table2) {
                let editDataArry = JSON.parse(reponseData.Table2[0].ItemCategories);
                for(let j = 0; j < editDataArry.length; j++){
                  this.categories.push({
                    'cid': editDataArry[j].cid,
                    'cnm': editDataArry[j].cnm,
                    'sub': editDataArry[j].sub ? editDataArry[j].sub : '',
                });
              }
                
            }
        }
        this.categories.sort((a:any,b:any) => a.cnm.localeCompare(b.cnm));
        console.log(this.categories)
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    // else {
    //     alert(res.message);
    // }
  }

  //open() - for open add and edit categories
  open(content: any, id:number) { 
    this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'my-class', backdrop: 'static', keyboard: false });
      this.modalReference.result.then((result: any) => {
          this.closeResult = `Closed with: ${result}`;
      },
          (reason: any) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
      if(id == 0){
        this.isEditCategory = false;
        this.tempData.categoryName = '';
      }
      else if(id != 0){
        var CatData = this.categories.filter(function (element: any, index: any) {
          return (element.cid == id);
        });
        this.isEditCategory = true;
        this.ind = id;
        const catOld:string = CatData[0].cnm;
        this.tempData.categoryName = catOld;
      }
  }

  private getDismissReason(reason: any): string {
    this.isEditCategory = false;
      if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
      } else {
          return `with: ${reason}`;
      }
      this.isEditCategory = false;
  }

  public closeModal($event: any) {
    this.isEditCategory = false;
      this.modalReference.close();
      if ($event) {
          this.changingValue.next($event);
      }
  }

  //saveNewCat() - add new categories
  saveNewCat(){
    var catName = this.tempData.categoryName;
    var dupData = this.categories.filter(function (element: any, index: any) {
      return (element.cnm.toUpperCase() == catName.toUpperCase());
    });
    if(catName == ''){
      this.apiService.successAlert("Please enter category name.")
      return;
    } 
    else if(dupData.length > 0){
      this.apiService.successAlert("This category already exists.");
      this.tempData.categoryName = '';
      return;
    }
    this.tempData.type = 'ITMCTGC' 
      this.save()
      this.reset();
      this.modalReference.close();

   return
    let flag = false;
    let temp = {
      'cid': this.categories.length + 1,
      'cnm': catName,
      'sub': [],
    }
    for (let i = 0; i < this.categories.length; i++) {
      if(catName.toUpperCase() == this.categories[i].cnm.toUpperCase()){
        flag = true
        break
      }
    }
    if(!flag){
      this.categories.push(temp);
      this.tempData.categoryName = '';
      this.save()
      this.modalReference.close();
    }
    else
    {
      this.apiService.successAlert("This category already exists.")
      this.tempData.categoryName = '';
      return;
    }
  }  
 
  //editCatSave() - edit categories
  editCatSave(){  
    var name = this.tempData.categoryName
    var id = this.ind
    var CatData = this.categories.filter(function (element: any, index: any) {
      return (element.cid == id);
    });
    if(name == ''){
       this.tempData.categoryName = CatData[0].cnm;
       this.apiService.successAlert("Please enter category name.")
      return;
    }
    
    this.tempData = {
      subCategoryID: 0,
      categoryID: id,
      type: 'ITMCTGC',
      categoryName: name
    }
    let flag = false;
    if(CatData[0].cnm == name){
      flag = false
    }
    else{
      for (let i = 0; i < this.categories.length; i++) {
        if(name == this.categories[i].cnm){
          flag = true
          break
        }
      }
    }
    
    if(!flag){
      for(let i = 0; i < this.categories.length; i++){
        if(this.categories[i].cid == CatData[0].cid){
          this.categories[i].cnm = name;
          break
        }
      }
      this.save()
      this.modalReference.close();
      this.reset();
    }
    else
    {
      this.tempData.categoryName = CatData[0].cnm;
      this.apiService.successAlert("This categories already exists.")
      return;
    }
  }

  //deleteCat() - delete categories
  deleteCat(i: number){
    if(this.categories[i].sub.length > 0){
      this.apiService.successAlert("This category cannot be deleted because there are sub-categories linked with it.");
      return;
    }
    var CatData = this.categories.filter(function (element: any, index: any) {
      return (index == i);
    });
    if(CatData.length > 0){
      this.tempData = {
        subCategoryID: 0,
        categoryID: CatData[0].cid,
        type: 'ITMCTGCD',
        categoryName: CatData[0].cnm
      }
    }
    if(confirm("Do you wish to delete this category?")){
      this.categories.splice(i, 1);
      this.save()  
    }
     
  }

  // save final data
  save(){
    var tempData = [{
      'ChangeType': this.tempData.type,
      'GSTLdgrs':'',
      'Units': '',
      'Stores':'',
      'ItemCategories': '', //JSON.stringify(this.categories),
      'PrdJobStages': '',
      'ValnMethod':1,
      'PrdRejnReasons': '',
      'HSNSAC':'',
      'CategoryID': this.tempData.categoryID,
      'SubCategoryID': this.tempData.subCategoryID,
      'CategoryName': this.tempData.categoryName
  }]
  let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'set',
      moduleID: 6,
      data: JSON.stringify(tempData)
  }];
  this.apiService.sendChange(myParams, this.successEntry.bind(this), this.failureResp.bind(this));
  }

   //successVchrEntry - success voucher entry handler
   successEntry(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var ErpData = JSON.parse(res.updatePackage);
          if (ErpData.Table1) {
            let coockieData = [];
            coockieData.push(ErpData.Table1[0]);
            let ErpAgn = JSON.stringify(coockieData);
            localStorage.setItem("ERP_Agn", ErpAgn)
          }
          if (ErpData.Table2) {
            let cookieData2 = [];
            cookieData2.push(ErpData.Table2[0]);
            let ErpCfgData = JSON.stringify(cookieData2);
            localStorage.setItem("ERP_Cfg", ErpCfgData)
          }
    }
      this.categories = [];
        this.getCategory();      
        this.modalReference.close();
    }
  }

  openSubCat(content: any, id:any){
    var CatData = this.categories.filter(function (element: any, index: any) {
      return (element.cid == id);
    });
    this.modalReference = this.modalService.open(SubCategoriesComponent, { windowClass : "subCatSelectionModalClass", backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.typeID = id;
    
    this.modalReference.componentInstance.CName = CatData[0].cnm;
    this.modalReference.componentInstance.mdlRef = this.modalReference;

    
    let sub = {
      cid: CatData[0].cid,
      sub: CatData[0].sub,
      cnm: CatData[0].cnm,
      categories: JSON.stringify(this.categories)
    }
    //this.router.navigate(['SubCategories']);
    this.dataSer.fn_dataTransfer(sub);
    $(".modal-content").css("display", "none !important");
  }

  //back() - back to settings
  back(){
    this.router.navigate(['Settings']);
  }


  closeModel() {
    let doneObj = {
      action: 'Done',
      obj: null
    }
    this.mdlRef.close(doneObj);
    // this.activeModal.dismiss();
  }

  backBtn() {
    window.history.back();
  }

  // color change 
  changeColor(ind: any){
    var clr = ""
    switch(ind) { 

      case 0: { 
        clr = 'orangeBadge'
         break; 
      } 
      case 1: {
        clr = 'yellowBadge'
        break; 
      } 
      case 2: { 
        clr = 'greenBadge'
         break; 
      } 
      case 3: { 
        clr = 'tealBadge'
         break; 
      } 
      case 4: { 
        clr = 'blueBadge'
         break; 
      } 
      case 5: { 
        clr = 'darkBlueBadge'
         break; 
      } 
      case 6: { 
        clr = 'brownBadge'
         break; 
      } 
    
   }
   return clr; 
  }

  reset(){
    this.tempData = {
      subCategoryID: 0,
      categoryID: 0,
      categoryName: '',
      type: '' 
    }
  }

}
